import {
	type DataKYCFileTctWithFile,
	KycFileCertificationStatus,
} from '@dealstack/shared/lib/generated';

type CertificationFields = Pick<
	DataKYCFileTctWithFile,
	'certificationStatus' | 'certificationRequired'
>;

/** The certifier has not signed yet, so the file cannot be approved. */
export const isAwaitingCertifier = (file: CertificationFields): boolean =>
	file.certificationStatus === KycFileCertificationStatus.PENDING_CERTIFIER;

/**
 * A proof that still owes the programme a certification cannot be approved — waiting on its
 * certifier, or never certified at all. Mirrors the gate in `applyKycFileStatusUpdate`.
 */
export const isCertificationOutstanding = (file: CertificationFields): boolean =>
	isAwaitingCertifier(file) ||
	(file.certificationRequired &&
		file.certificationStatus === KycFileCertificationStatus.UNCERTIFIED);

/** Only files that need certifying, or were certified anyway, get the panel. */
export const hasCertificationPanel = (file: CertificationFields): boolean =>
	file.certificationRequired ||
	file.certificationStatus !== KycFileCertificationStatus.UNCERTIFIED;

/** The investor's upload before stamping, when it differs from the file under review. */
export const originalUploadFileId = (
	file: Pick<DataKYCFileTctWithFile, 'fileId' | 'certificationReview'> | undefined
): string | undefined => {
	const originalFileId = file?.certificationReview?.originalFileId;
	return originalFileId && originalFileId !== file.fileId ? originalFileId : undefined;
};
